import React from 'react';
import './LogosSlider.css';
import {
  cssIcon,
  firebaseIcon,
  htmlIcon,
  javascriptIcon,
  pythonIcon,
  reactIcon,
  reduxIcon,
} from '../../../assets/icons/index';

const LogosSlider = () => {
  const icons = [
    { nombre: 'JavaScript', icono: javascriptIcon },
    { nombre: 'Python', icono: pythonIcon },
    { nombre: 'React', icono: reactIcon },
    { nombre: 'Redux', icono: reduxIcon },
    { nombre: 'Firebase', icono: firebaseIcon },
    { nombre: 'HTML', icono: htmlIcon },
    { nombre: 'CSS', icono: cssIcon },
  ];

  const renderIcons = (keyPrefix) =>
    icons.map((icon, index) => (
      <div key={`${keyPrefix}-${index}`} className="icon-card">
        <img src={icon.icono} alt={`${icon.nombre} icon`} className="icon-image" />
        <p className="icon-name">{icon.nombre}</p>
      </div>
    ));

  return (
    <div className="slider-wrapper">
      <div className="slider-track">
        <div className="slider-group">{renderIcons('group-a')}</div>
        <div className="slider-group" aria-hidden="true">
          {renderIcons('group-b')}
        </div>
      </div>
    </div>
  );
};

export default LogosSlider;
